import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { discardInvoiceDraft } from "../../api/invoice";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import { Invoice } from "../../models/invoice";

interface InvoiceDiscardDraftModalProps {
  show: boolean;
  invoice?: Invoice;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const InvoiceDiscardDraftModal: React.FC<InvoiceDiscardDraftModalProps> = ({
  show,
  invoice,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const onDiscardClick = async () => {
    if (invoice !== undefined) {
      setSubmitting(true);
      const requestStatus = await discardInvoiceDraft(invoice.id!);

      if (requestStatus.status !== SUCCESS) {
        const msg = requestStatus.detail ?? "Error al descartar el borrador";
        errorAlert(msg);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Descartar Borrador</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>¿Estás seguro que deseas descartar este borrador?</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDiscardClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Descartando..." : "Descartar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default InvoiceDiscardDraftModal;
